const USER_GUIDE_MAP = {
  "Sample Item Images": "https://w.amazon.com/bin/view/ItemMatrix/Customers/Image_Gallery_Website_User_Guide/",
  "Canonical Images" : "https://w.amazon.com/bin/view/ItemMatrix/Customers/Image_Gallery_Website_User_Guide_Canonical_Representation/"
};

const getUserGuide = (imageSetsName: string) => {
  const imageSetsNameTyped = imageSetsName as keyof typeof USER_GUIDE_MAP;
  return USER_GUIDE_MAP[imageSetsNameTyped]
};

export const IMAGE_SETS_MENU = [
  {
    title: "Sample Item Images",
    path: "/sampleItemImages",
    disabled: false,
  },
  {
    title: "Canonical Images",
    path: "/canonicalImages",
    disabled: false,
  },
];

export const getHelpMenu = (imageSetsName: string) => {
  const userGuide = getUserGuide(imageSetsName);

  const helpMenu = [
    {
      title: "User Guide",
      path: userGuide,
    },
    {
      title: "About Us",
      path: "https://w.amazon.com/bin/view/ItemMatrix",
    },
    {
      title: "Contact Us",
      path: "https://w.amazon.com/bin/view/ItemMatrix/#HContactUs",
    },
  ];

  return helpMenu;
};
